import { render, staticRenderFns } from "./MensaOrder.vue?vue&type=template&id=da6b8838&scoped=true&"
import script from "./MensaOrder.vue?vue&type=script&lang=js&"
export * from "./MensaOrder.vue?vue&type=script&lang=js&"
import style0 from "./MensaOrder.vue?vue&type=style&index=0&id=da6b8838&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da6b8838",
  null
  
)

export default component.exports